<template>
  <lw-overlay
    :size="'c1'"
    :colour="'cream'"
  >
    <div class="grid grid-columns-4_md align-content-center vh75">
      <div class="grid-column-start-2_md grid-column-end-4_md">
        <h1 class="mb2">Add a red flag</h1>
        <form @submit.prevent="addRedFlag">
          <fieldset>
            <lw-text-input
              v-validate="'required'"
              :id="'title'"
              :label="'Title'"
              :size="'large'"
              :name="'title'"
              :error="errors.first('title')"
              v-model="title"/>
            <lw-text-area
              :id="'description'"
              :size="'large'"
              :label="'Notes or context for this red flag'"
              :name="'description'"
              v-model="description"/>
            <div class="flex justify-content-space-between">
              <button
                class="invisible-button negative-button"
                @click.prevent="cancel">Cancel</button>
              <button
                type="submit"
                name="submit"
                class="large-button accent-button mr1">Save red flag</button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </lw-overlay>
</template>

<script>
import * as firebase from 'firebase'
import { mapGetters } from 'vuex'
import TextInput from '../livewires/TextInput.vue'
import TextArea from '../livewires/TextArea.vue'
import Overlay from '../livewires/Overlay.vue'

export default {
  components: {
    lwTextInput: TextInput,
    lwTextArea: TextArea,
    lwOverlay: Overlay
  },
  data () {
    return {
      title: '',
      description: ''
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'organization',
      'roles'
    ])
  },
  methods: {
    addRedFlag () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('saveState', false)
          const payload = {
            title: this.title,
            description: this.description,
            organization: this.organization.id,
            owner: this.user.id,
            created: firebase.default.firestore.FieldValue.serverTimestamp(),
            updated: firebase.default.firestore.FieldValue.serverTimestamp(),
            archived: false
          }
          this.$store.dispatch('addRedFlag', payload).then(response => {
            this.$router.push({ name: 'redflag', params: { id: response } })
          })
        }
      })
    },
    cancel () {
      this.$router.go(-1)
    }
  }
}
</script>
